module.exports = __webpack_public_path__ + "static/buckle-489b63823a55bccd9d01df9765c80111.jpg";